"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInputFocus = void 0;
var react_1 = require("react");
function useInputFocus() {
    var field = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var _a;
        (_a = field.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    return field;
}
exports.useInputFocus = useInputFocus;
